'use strict';

function Storeys (floor, totalFloors) {
  this.floor = floor;
  this.totalFloors = totalFloors;
}

Storeys.prototype.getFloor = function () {
  const intFloor = parseInt(this.floor);
  let floorRoom = intFloor;

  if (this.floor === null) {
    floorRoom = '';
  } else if (intFloor === 0) {
    floorRoom = Storeys.FLOOR_BASE;
  } else if (intFloor === -1) {
    floorRoom = Storeys.FLOOR_BASEMENT;
  }

  return floorRoom;
};

Storeys.prototype.getLabel = function (type = Storeys.TYPE_LONG) {
  const floorRoom = this.getFloor();

  if (type === Storeys.TYPE_SMALL) {
    return (floorRoom || '-') + '/' + (this.totalFloors || '-');
  }

  if (type === Storeys.TYPE_LONG) {
    const floor = floorRoom || '-';
    const floorLabel = (floor !== Storeys.FLOOR_BASE && floor !== Storeys.FLOOR_BASEMENT) ? 'Этаж: ' : '';

    return floorLabel + floor + '/' + (this.totalFloors || '-');
  }

  if (type === Storeys.TYPE_SHORT) {
    const prefix = floorRoom ? 'этаж:\u00A0' : (this.totalFloors ? 'этажей:\u00A0' : '');

    return prefix + [floorRoom, (this.totalFloors || '')].filter(Boolean).join('/');
  }
};

Storeys.TYPE_LONG = 'long';
Storeys.TYPE_SHORT = 'short';
Storeys.TYPE_SMALL = 'small';
Storeys.FLOOR_BASE = 'цоколь';
Storeys.FLOOR_BASEMENT = 'подвал';

export default Storeys;



// WEBPACK FOOTER //
// ./src/classes/common/storeys.js